export default __webpack_public_path__ + "static/media/fontello.2f77eefb.ttf";